import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var dropdownMenuListItemComponentName = 'QuantumDropdownMenuListItem';
export function getDropdownMenuListItemUtilityClass(slot) {
    return generateUtilityClass(dropdownMenuListItemComponentName, slot);
}
export var dropdownMenuListItemClasses = generateUtilityClasses(dropdownMenuListItemComponentName, [
    'root',
    'sizeLarge',
    'detailed',
    'disabled',
    'colorDanger',
    'selected',
    'content',
    'title',
    'description',
    'icon',
    'startIcon',
    'endIcon',
    'selectedIcon',
]);
